import { OnInit, Component, Input } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { PlanCompensatorioModel } from 'src/app/models/planCompensatorio.model';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Component({
    selector: 'app-informacion-compensatorio',
    templateUrl: './informacion-compensatorio.component.html',
    styleUrls: ['./../plan-compensatorio.component.scss']
})
export class InformacionCompensatorioComponent implements OnInit {

    @Input() infoCompensatorio: PlanCompensatorioModel;

    public campoEstado: string;
    public consultaEstados: string[];
    public placeholderDate: string;
    fechaInicialCompensacion: NgbDate;
    fechaFinalCompensacion: NgbDate;
    fechaFinalRepCompensacion: NgbDate;
    festivos = [];

    constructor(
        private spinner: NgxSpinnerService,
        private urlService: UrlService,
        private global: GlobalService,
        private alertService: AlertService,
    ) {
        this.consultaEstados = [];
    }

    ngOnInit() {
        this.placeholderDate = ConstantesService.SELECCION_FECHA;
        this.consultarFestivos();
        this.obtenerEstados();
    }

    /**
     * Consulta los tipo de estado Existente
     */
    public obtenerEstados() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'EstadoCompensacion']);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.consultaEstados = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener los Estados');
            }
        );
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }

      /**
    * Método que valida las fechas con los festivos
    */
   public consultarFestivos() {
    const serviceProvider = 'consultarFestivos';
    const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
    this.global.getGenerico(url).subscribe(
        data => {
            this.festivos = data;
        }, err => {
            this.cathException('No es posible Obtener los festivos');
        });
}

    validarFestivos(event, atributo) {
        this.infoCompensatorio[atributo] = event;
        const fecha = moment(event).format(ConstantesService.FORMATO_FECHA_ISO)
        if (this.festivos.find((x: string) => moment(x).format(ConstantesService.FORMATO_FECHA_ISO) === fecha)) {
            this.cathException('Las fechas de compensación no pueden ser días festivos, por favor verifique');
            return;
        }

    }
}
